import type { SuggestionControls } from '#packages/baseUI';
import * as helpIds from '#packages/helpIds';
import { translate } from '#packages/i18n';
import type { Content } from './types';
import experiment from 'experiment';

const DISPLAY_NAME = 'ChangeBusinessTypePanel';

export { DISPLAY_NAME };

export const content: Content = {
  dataHook: 'change-business-type-panel-modal',
  panelTitle: 'content_injection_change_modal_title',
  inputLabel: 'content_injection_change_modal_search_label',
  inputPlaceholder: 'content_injection_change_modal_placeholder_label',
  modalSubtitleText: 'content_injection_change_modal_subtitle',
  modalSubSubtitleText: 'content_injection_change_modal_note',
  learnMoreCTA: 'content_injection_change_modal_subtitle_learn_more_cta',
  helpId: helpIds.businessTypePanel.LEARN_MORE,
  confirm: 'content_injection_change_modal_save_button',
  cancel: 'content_injection_change_modal_cancel_button',
};

const toneOfVoiceCTA: string = experiment.isOpen('se_newContentForAI')
  ? translate('ai_text_creator_chat_generate_header_default_tone_cta')
  : translate('ai_text_creator_chat_header_default_tone_cta');

export const TONE_OF_VOICE = [
  {
    type: 'button',
    label: 'ai_text_creator_chat_refine_change_tone_casual',
    value: translate('ai_text_creator_chat_refine_change_tone_casual'),
  },
  {
    type: 'button',
    label: 'ai_text_creator_chat_refine_change_tone_professional',
    value: translate('ai_text_creator_chat_refine_change_tone_professional'),
  },
  {
    type: 'button',
    label: 'ai_text_creator_chat_refine_change_tone_enthusiastic',
    value: translate('ai_text_creator_chat_refine_change_tone_enthusiastic'),
  },
  {
    type: 'button',
    label: 'ai_text_creator_chat_refine_change_tone_confident',
    value: translate('ai_text_creator_chat_refine_change_tone_confident'),
  },
  {
    type: 'button',
    label: 'ai_text_creator_chat_refine_change_tone_funny',
    value: translate('ai_text_creator_chat_refine_change_tone_funny'),
  },
  {
    type: 'button',
    label: 'ai_text_creator_chat_header_default_tone_cta',
    value: toneOfVoiceCTA,
  },
] as SuggestionControls;

export const FIELD_NAME_BUSINESS_TYPE = 'business type';
export const FIELD_NAME_BUSINESS_NAME = 'business name';
export const FIELD_NAME_TONE_OF_VOICE = 'tone of voice';
export const YES = 'yes';
export const NO = 'no';
